module.exports = __webpack_public_path__ + "static/media/sunflower-bottom-corner.e57ab7e4.png";